import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get paymentType
export const getPaymentType = createAsyncThunk("paymentType/getPaymentType", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getPaymentType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all paymentType
export const getAllPaymentType = createAsyncThunk("paymentType/getAllPaymentType", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllPaymentType();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("paymentType/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("paymentType/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "paymentType/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePaymentType({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create paymentType
export const createPaymentType = createAsyncThunk(
  "paymentType/createPaymentType",
  async (data, { rejectWithValue }) => {
    const { name, isActive } = data;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.createPaymentType(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePaymentType = createAsyncThunk(
  "paymentType/updatePaymentType",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, isActive } = values;
    try {
      const body = JSON.stringify({ name, isActive });
      const { data } = await API.updatePaymentType(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("paymentType/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
